import gql from "graphql-tag";
import { offeredFragment } from "./fragments";

export const GET_PROJECT_OFFERED = gql`
  query getProjectOffered($projectId: ID!, $offset: Int!, $limit: Int) {
    projectOffered(projectId: $projectId, offset: $offset, limit: $limit) {
      hasMore
      items {
        ...OfferedFragment
      }
    }
  }
  ${offeredFragment}
`;

export const GET_ALL_OFFERED = gql`
  query getAllOffered(
    $offset: Int!
    $limit: Int
    $invoiced: Boolean
    $validated: Boolean
  ) {
    offered(
      offset: $offset
      limit: $limit
      invoiced: $invoiced
      validated: $validated
    ) {
      hasMore
      items {
        ...OfferedFragment
      }
    }
  }
  ${offeredFragment}
`;
